<template>
  <div class="h-news-space">
    <h1 class="title1">行业要闻</h1>
    <div class="h_news_cup">
      <el-row>
        <el-col :span="11">
          <div class="h_news_main">
            <img :src="toShowNews.path" width="500" height="335" alt="" @click="checkNews(toShowNews)">
            <div class="h_main_title" @click="checkNews(toShowNews)">{{toShowNews.title1}}</div>
            <div class="h_main_text" @click="checkNews(toShowNews)">{{toShowNews.content}}</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="h_news_list">
            <div v-for="(item,index) in homeNewsList" :key="index" class="his-season-sub">
              <div style="float:left;width:26%;" @click="checkNews(item)">
                <img :src="item.path" width="130" height="95" alt="">
              </div>
              <div class="hisTopic">
                <div style="font-size:18px;">
                  <span class="highLight" @click="checkNews(item)">{{item.title1}}</span>
                </div>
                <div>发布时间： {{item.time}} </div>
                <div> {{item.content}} </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="news-check-more">
      <el-button type="primary" @click="seeNewsSpace">查看更多<i class="el-icon-right  el-icon--right"></i></el-button>
    </div>
  </div>
</template>
<script>
import { homeBriefNews } from '@/api/frontApi/frontHome';
export default {
  data() {
    return {
      toShowNews: {},
      homeNewsList: []
    };
  },
  created() {
    this.getHomeNews();
  },
  computed: {
    defaultImg() {
      return this.$store.state.defaultImg;
    }
  },
  methods: {
    getHomeNews() {
      let newsSelf = this;
      homeBriefNews({ pageNo: 1, pageSize: 5 }).then(res => {
        let tempArr = res.data.list;
        newsSelf.homeNewsList = [];
        for (let i = 0; i < tempArr.length; i++) {
          let tempObj = {
            path: '',
            title1: '',
            time: '',
            content: '',
            newsId: ''
          };
          if (tempArr[i].newsMainImg) {
            tempObj.path = tempArr[i].newsMainImg;
          } else {
            tempObj.path = this.defaultImg;
          }
          tempObj.title1 = tempArr[i].newsTitle;
          // tempObj.title2 = tempArr[i].newsSubtitle;
          tempObj.time = tempArr[i].newsCreateTime;
          tempObj.content = tempArr[i].newsSummary;
          tempObj.newsId = tempArr[i].newsId;
          newsSelf.homeNewsList.push(tempObj);
        }
        this.toShowNews = this.homeNewsList[0];
        this.homeNewsList.shift();
      });
    },
    checkNews(newsObj) {
      this.$router.push({
        name: 'newsInfo',
        params: { newsId: newsObj.newsId }
      });
    },
    seeNewsSpace() {
      this.$router.push({ name: 'news' });
    }
  }
};
</script>
<style lang="stylus" scoped>
.h-news-space {
  padding: 10px 0 25px;
  width: 100%;
  background-color: #f3f3f3;

  .title1 {
    width: 100%;
    text-align: center;
  }

  .h_news_cup {
    width: 70%;
    margin: 0 auto;
    min-width: 1130px;

    .h_news_main {
      width: 100%;
      font-size: 18px;
      min-width: 520px;
    }
    .h_news_main img{
      cursor:pointer;
    }

    .h_news_list {
      min-width: 630px;

      .his-season-sub {
        overflow: hidden;
        height: 100px;
        width: 100%;
        margin-bottom: 5px;
        cursor: pointer;

        .his_sub_img {
          float: left;
          width: 130px;
          height: 95px;
          overflow: hidden;
        }

        .his_sub_img img {
          transition: all 2s;
        }

        .his_sub_img img:hover {
          transform: scale(1.2);
        }

        .hisTopic {
          float: left;
          width: 72%;
          margin-left: 15px;
        }

        .hisTopic div {
          width: 100%;
          margin-bottom: 8px;
          font-size: 14px;
        }
      }
    }
  }
}
.news-module {
  overflow: hidden;
  margin: 10px auto;
}
.title1 {
  width: 100%;
  text-align: center;
}
.news-module-main {
  width: 30%;
  font-size: 18px;
}
.new-his-list {
  width: 27%;
  float: left;
  font-size: 18px;
  margin-left: 2%;
}

.new-his-list div {
  cursor: pointer;
}

.h_main_title {
  text-align: center;
  width: 100%;
  cursor: pointer;
}
.news-main-text {
  font-size: 14px;
  margin-top: 5px;
  cursor: pointer;
}
.news-check-more {
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/homeNews.vue